import ServerTime from './ServerTime';
import getServerClientTimeOffset from './getServerClientTimeOffset';

export * from './serverClientTimeOffsetOnWindow';
export { getServerClientTimeOffset };
export default ServerTime;
